import type { ApiError } from "@/services/api";
import type { GenericObject } from "@/types";

import { validationErrorParser } from "@/modules/form-validation";

export const getFieldApiError = (fieldName: string, error?: ApiError) => {
  const parseErrors = validationErrorParser(error, [
    fieldName,
  ]) as GenericObject<string>;

  return fieldName in parseErrors ? parseErrors[fieldName] : undefined;
};
